import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import Axios from 'axios';

import helper from './plugins/helper';
import store from './plugins/store';

import '@/css/basic.css';

Vue.config.productionTip = false;
Vue.prototype.$helper = helper;
Vue.prototype.$store = store;
Vue.prototype.$axios = Axios;

new Vue({
    vuetify,
    router,
    render: h => h(App),
}).$mount('#app');
